import MuiButtonBase, {
  type ButtonBaseProps,
} from "@mui/material/ButtonBase";

export type { ButtonBaseProps };

export function ButtonBase(props: ButtonBaseProps) {
  return <MuiButtonBase {...props} />;
}
